import { render } from "./narvar2.vue?vue&type=template&id=a5789b42&scoped=true"
import script from "./narvar2.vue?vue&type=script&lang=js"
export * from "./narvar2.vue?vue&type=script&lang=js"

import "./narvar2.vue?vue&type=style&index=0&id=a5789b42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5789b42"]])

export default __exports__